module.exports = __webpack_public_path__ + "static/media/land.0852dcee.svg";